module.exports = __webpack_public_path__ + "img/item-active.02e928c9.svg";